export default {"src":"/_next/static/media/tiktok.a297ad2c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};